/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as i from "react";
import * as b from "react-dom";
import e from "prop-types";
import { DialogTitleBar as k } from "./DialogTitleBar.mjs";
import { DialogActionsBar as c } from "./DialogActionsBar.mjs";
import { dispatchEvent as A, Keys as N, keepFocusInContainer as O, validatePackage as P, shouldShowValidationUI as S, ZIndexContext as d, focusFirstFocusableChild as Z, classNames as F, WatermarkOverlay as L, canUseDOM as _, createPropsContext as B, withIdHOC as K, withPropsContext as M } from "@progress/kendo-react-common";
import { packageMetadata as h } from "./package-metadata.mjs";
import { getMaxZIndex as z } from "./utils.mjs";
import { DEFAULT_DIALOGS_ZINDEX as G, ZINDEX_DIALOGS_STEP as p, DATA_DIALOGS_ID as R } from "./constants.mjs";
const o = class o extends i.Component {
  constructor(s) {
    super(s), this.context = 0, this.titleId = this.generateTitleId(), this.contentId = this.generateContentId(), this.showLicenseWatermark = !1, this.activeElement = null, this.onCloseDialog = (t) => {
      t.preventDefault(), A(this.props.onClose, t, this, void 0), setTimeout(() => {
        this.activeElement && this.activeElement.focus();
      });
    }, this.onKeyDown = (t) => {
      t.keyCode === N.esc && this.props.onClose && (t.preventDefault(), this.onCloseDialog(t)), O(t, this.element);
    }, this.getCurrentZIndex = () => !this.state || this.context === void 0 ? this.context ? this.context : G : this.state.zIndex > (this.context ? this.context + p : 0) ? this.state.zIndex : this.context + p, this.getDocument = () => this.props.appendTo ? this.props.appendTo.ownerDocument : document, P(h), this.showLicenseWatermark = S(h), this.activeElement = document.activeElement;
  }
  get _id() {
    return this.props.id + "-accessibility-id";
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.element && (this.props.autoFocus ? this.element.focus() : Z(this.element), this.setState({
      zIndex: z(this.getCurrentZIndex(), this.getDocument(), this._id)
    }));
  }
  /**
   * @hidden
   */
  render() {
    const s = this.props.id !== void 0 ? this.props.id : this.titleId, { title: t, width: m, height: u, children: g, minWidth: y, dir: I, style: f, contentStyle: D, modal: x = !0 } = this.props, r = i.Children.toArray(g), C = this.getContent(r), w = this.getActionBar(r), v = t ? {
      "aria-labelledby": s
    } : null, E = this.props.closeIcon !== void 0 ? this.props.closeIcon : !0, a = this.getCurrentZIndex(), l = /* @__PURE__ */ i.createElement(d.Provider, { value: a }, /* @__PURE__ */ i.createElement(
      "div",
      {
        [R]: this._id,
        className: "k-dialog-wrapper" + (this.props.className ? " " + this.props.className : ""),
        onKeyDown: this.onKeyDown,
        tabIndex: 0,
        dir: I,
        style: {
          zIndex: a,
          ...f
        },
        ref: (T) => this.element = T
      },
      x && /* @__PURE__ */ i.createElement(
        "div",
        {
          className: "k-overlay",
          style: this.props.overlayStyle
        }
      ),
      /* @__PURE__ */ i.createElement(
        "div",
        {
          ...v,
          className: F(
            "k-window k-dialog",
            {
              [`k-window-${this.props.themeColor}`]: this.props.themeColor
            }
          ),
          role: "dialog",
          "aria-labelledby": s,
          "aria-modal": !0,
          "aria-describedby": this.contentId,
          style: { width: m, height: u, minWidth: y }
        },
        this.props.title && /* @__PURE__ */ i.createElement(
          k,
          {
            closeIcon: E,
            onCloseButtonClick: this.onCloseDialog,
            id: s
          },
          t
        ),
        /* @__PURE__ */ i.createElement("div", { className: "k-window-content k-dialog-content", style: D, id: this.contentId }, C),
        w,
        this.showLicenseWatermark && /* @__PURE__ */ i.createElement(L, null)
      )
    ));
    return _ ? this.props.appendTo !== null ? b.createPortal(l, this.props.appendTo || document.body) : l : null;
  }
  getActionBar(s) {
    return s.filter((t) => t && t.type === c);
  }
  getContent(s) {
    return s.filter((t) => t && t.type !== c);
  }
  generateTitleId() {
    return "dialog-title-" + this._id;
  }
  generateContentId() {
    return "dialog-content-" + this._id;
  }
};
o.displayName = "Dialog", o.propTypes = {
  title: e.any,
  id: e.string,
  dir: e.string,
  style: e.object,
  closeIcon: e.bool,
  width: e.oneOfType([e.number, e.string]),
  height: e.oneOfType([e.number, e.string]),
  minWidth: e.oneOfType([e.number, e.string]),
  autoFocus: e.bool
}, o.defaultProps = {
  autoFocus: !1
}, o.contextType = d;
let n = o;
const U = B(), X = K(M(U, n));
X.displayName = "KendoReactDialog";
export {
  X as Dialog,
  U as DialogPropsContext
};
